<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 mb-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              clearable
              @clear="cleanFarm()"
              @change="showCalendar()"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm farm-form"
              size="large"
              v-model="calibrationForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('common_words.allotment') }} *</label>
            <br />
            <el-select
              clearable
              @clear="cleanLot()"
              @change="hideView"
              filterable
              class="select-primary custom-width-select shadow-sm required-lots lote-form"
              size="large"
              v-model="calibrationForm.lot_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in lots"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + '-' + option.id"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3"
            v-if="isShowCalendar"
          >
            <label>{{ $t('common_words.calendar') }} *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-calendar shadow-sm date-form"
              size="large"
              v-model="calibrationForm.calendar_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in calendars"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
            <label>{{ $t('calibration.lever_gang') }}</label>
            <fg-input
              ref="gang"
              min="1"
              type="number"
              v-model="calibrationForm.gang"
              class="text-center input-gang required-gang"
              name="calibration.lever_gang"
              :placeholder="`${$t('calibration.lever_gang')}...`"
              @input="changeGang"
            />
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              :picker-options="pickerOptions"
              class="shadow-sm required-date date-form"
              v-model="calibrationForm.date_sel"
              type="date"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
            <div class="row custom-mt-30">
              <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mb-2">
                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  @click="validate"
                  style="width: inherit"
                >
                  {{ $t('common_words.generate') }}
                </l-button>
              </div>
            </div>
          </div>
        </div>
        <br />
      </card>

      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        :title="$t('calibration.calibration_catch')"
        v-if="calibration"
      >
        <div class="mt-4 px-3">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="row mb-3">
              <div class="col-12 col-sm-4 col-md-4 col-lg-6 col-xl-6">
                <label class="font-weight-bold">{{
                  $t('calibration.number_of_bunches')
                }}</label>
                <select-component
                  rowClass=""
                  style="width: 100%"
                  :dataOptions="rowOptions"
                  :initialSelection="numRowsToAdd"
                  :isMultiple="false"
                  @onChange="handleNumRowsChange"
                  modelName="numRowsToAdd"
                />
              </div>
              <div
                class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 custom-mt-30"
              >
                <l-button type="success" @click="addMultipleRows">
                  <em class="fa fa-plus mr-2"></em>
                  {{ $t('common_words.add') }}
                </l-button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead class="cusmtom-thead-color">
                  <tr class="cusmtom-thead-color">
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('calibration.number_of_bunches') }}
                    </th>
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('calibration.hands_type') }}
                    </th>
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('common_words.age') }}
                    </th>
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('production.ribbon') }}
                    </th>
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('calibration.calibration') }}
                    </th>
                    <th class="text-center p-3 custom-header-label">
                      {{ $t('common_words.options') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(_, index) in calibrationForm.nCalibration"
                    :key="index"
                  >
                    <!-- Número de racimos -->
                    <td
                      class="text-center custom-td-pd"
                      style="vertical-align: middle; min-width: 70px"
                    >
                      {{ calibrationForm.clusters[index] }}
                    </td>

                    <!-- Tipo de Mano -->
                    <td
                      class="text-center custom-td-pd"
                      style="min-width: 300px"
                    >
                      <select-component
                        :class="`mt-3 col-12`"
                        :isMultiple="false"
                        :dataOptions="calibrationTypes"
                        :requireClass="`required-calibration_types`"
                        :initialSelection="
                          calibrationForm.calibration_types_sel[index]
                        "
                        :indexSelect="index"
                        @onChange="handleFormChange"
                        modelName="calibration_types_sel"
                      />
                    </td>

                    <!-- Edad -->
                    <td
                      class="text-center custom-td-pd"
                      style="min-width: 100px"
                    >
                      <select-component
                        :class="`mt-3 col-12`"
                        :isMultiple="false"
                        :dataOptions="ages"
                        :requireClass="`required-calibration_age`"
                        :initialSelection="calibrationForm.ages_sel[index]"
                        :indexSelect="index"
                        @onChange="handleFormChange"
                        modelName="ages_sel"
                      />
                    </td>

                    <!-- Cinta (Color + Nombre) -->
                    <td
                      class="text-center custom-td-pd"
                      style="min-width: 120px"
                    >
                      <span
                        v-if="calibrationForm.ages_sel[index]"
                        class="col-12"
                        :style="getRibbonStyle(index)"
                      >
                        {{ getRibbonName(index) }}
                      </span>
                    </td>

                    <!-- Calibración -->
                    <td
                      class="text-center custom-td-pd"
                      style="min-width: 120px"
                    >
                      <fg-input
                        type="number"
                        min="1"
                        step="0"
                        class="m-3 text-center input-covered_area required-calibration"
                        v-model="calibrationForm.calibration[index]"
                        :name="`calibration.calibration${index}`"
                        v-validate="modelValidations.calibration"
                      />
                    </td>

                    <!-- Opciones -->
                    <td
                      class="text-center custom-td-pd"
                      style="min-width: 120px"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click.prevent="addRow()"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="calibrationForm.nCalibration > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="removeRow(index)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <hr />

          <div class="row">
            <div class="col-12">
              <div class="form-group has-label">
                <label>{{ $t('common_words.observation') }}</label>
                <br />
                <el-input
                  maxlength="300"
                  show-word-limit
                  type="textarea"
                  :rows="2"
                  placeholder="..."
                  v-model="calibrationForm.observation"
                  class="shadow-sm"
                ></el-input>
                <br />
                <br />
              </div>
            </div>
          </div>

          <div class="row" v-if="!messageAlert">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                @click="saveCalibration"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="deleteCalibrationDetails"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinForm from 'src/mixins/forms/mixin-form';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import MixinMenu from 'src/util/mixinMenu';
import mixinLocation from 'src/util/mixinLocation';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import i18n from 'src/i18n';
import { isset } from 'src/util/Util.js';

export default {
  data() {
    return {
      rowOptions: Array.from({ length: 10 }, (_, i) => ({
        id: i + 1,
        name: String(i + 1),
      })),
      numRowsToAdd: 1,
      calibrationForm: {
        calendar_sel: null,
        date_sel: new Date(moment().format('YYYY-MM-DD').replace(/-/, '/')),
        farm_id: null,
        lots_sel: [],
        calibration: [],
        nCalibration: 1,
        lot_id: null,
        ages_sel: [],
        ribbon_ids: [],
        calibration_type_id: null,
        calibration_types_sel: [],
        ribbon_codes: [],
        ribbon_text_colors: [],
        ribbon_names: [],
        clusters: [1],
        latitude: [],
        longitude: [],
        altitude: [],
        observation: '',
        user_id: this.$store.state.auth.user.id,
        gang: null,
      },
      calibration_catch_header_id: null,
      has_details: false,
      lots: [],
      farms: [],
      calibrationTypes: [],
      ribbonColorsByAge: [],
      calibration: false,
      isShowCalendar: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      messageAlert: null,
      showPreload: false,
      showTable: false,
      location: null,
      modelValidations: {
        calibration: {
          required: true,
          min_value: 0,
        },
      },
    };
  },
  computed: {
    calendars() {
      if (this.calibrationForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          if (element.id == this.calibrationForm.farm_id) {
            calendars = element.calendars;
          }
        });
        return calendars;
      } else {
        return [];
      }
    },
    ages() {
      return [
        { id: 8, name: '8' },
        { id: 9, name: '9' },
        { id: 10, name: '10' },
        { id: 11, name: '11' },
        { id: 12, name: '12' },
        { id: 13, name: '13' },
        { id: 14, name: '14' },
        { id: 15, name: '15' },
      ];
    },
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinNotification,
    MixinExport,
    MixinMenu,
    MixinForm,
    mixinLocation,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    async getLocation() {
      const locationData = await this.getPosition();
      return {
        lat: locationData.lat,
        lng: locationData.lng,
        alt: locationData.alt,
      };
    },

    async setLocation() {
      try {
        this.location = await this.getLocation();
        for (let i = 0; i < this.calibrationForm.nCalibration; i++) {
          this.$set(this.calibrationForm.latitude, i, this.location.lat);
          this.$set(this.calibrationForm.longitude, i, this.location.lng);
          this.$set(this.calibrationForm.altitude, i, this.location.alt);
        }
      } catch (error) {
        console.error('No se pudo obtener la ubicación:', error);
        SweetAlert.warning('common_words.geolocation_could_not_be_obtained');
      }
    },

    addMultipleRows() {
      const count = Number(this.numRowsToAdd) || 1;
      for (let i = 0; i < count; i++) {
        this.addRow();
      }
    },

    handleNumRowsChange(data) {
      this.numRowsToAdd = data.selects;
    },

    getRibbonColorByEdge(age) {
      if (!this.ribbonColorsByAge) return null;

      return this.ribbonColorsByAge.find((color) => color.age == age) || null;
    },

    getRibbonStyle(index) {
      const backgroundColor = this.calibrationForm.ribbon_codes[index];
      const color = this.calibrationForm.ribbon_text_colors[index];

      if (!backgroundColor) return {};

      return {
        backgroundColor: backgroundColor,
        color: color,
        borderRadius: '4px',
        fontWeight: 'bold',
        padding: '2px 2px',
        display: 'inline-block',
        minWidth: '80px',
      };
    },

    getRibbonName(index) {
      return this.calibrationForm.ribbon_names[index] || '';
    },

    addRow() {
      this.calibrationForm.nCalibration++;
      this.calibrationForm.clusters.push(this.calibrationForm.nCalibration);

      this.calibrationForm.calibration_types_sel.push(null);
      this.calibrationForm.ages_sel.push(null);
      this.calibrationForm.ribbon_ids.push(null);
      this.calibrationForm.calibration.push(null);

      this.calibrationForm.ribbon_codes.push(null);
      this.calibrationForm.ribbon_names.push(null);
      this.calibrationForm.ribbon_text_colors.push(null);
    },

    removeRow(index) {
      this.calibrationForm.nCalibration--;
      const fieldsToRemove = [
        'ages_sel',
        'calibration_types_sel',
        'calibration',
        'ribbon_codes',
        'ribbon_ids',
        'ribbon_names',
        'ribbon_text_colors',
        'clusters',
      ];

      fieldsToRemove.forEach((field) => {
        this.removeFromData(this.calibrationForm, field, index);
      });

      this.calibrationForm.clusters = Array.from(
        { length: this.calibrationForm.nCalibration },
        (_, i) => i + 1
      );
    },

    removeFromData(form, field, index) {
      try {
        if (!Array.isArray(form[field])) {
          console.warn(
            `El campo ${field} no es un array válido en el formulario.`
          );
          return;
        }
        const updatedField = form[field].filter((_, i) => i !== index);
        this.$set(form, field, updatedField);
      } catch (error) {
        console.error(`Error al actualizar ${field}: `, error);
      }
    },

    hideView() {
      this.showTable = false;
      this.showPreload = false;
    },

    handleFilterChange(data) {
      this.$set(this, data.name, data.selects);
    },

    handleFormChange(data) {
      try {
        switch (data.name) {
          case 'ages_sel':
            this.$set(this.calibrationForm.ages_sel, data.index, data.selects);
            const selectedAgeId = data.selects;

            if (selectedAgeId != null && selectedAgeId !== '') {
              const ribbonInfo = this.getRibbonColorByEdge(selectedAgeId);

              if (ribbonInfo) {
                this.$set(
                  this.calibrationForm.ribbon_codes,
                  data.index,
                  ribbonInfo.color_code
                );
                this.$set(
                  this.calibrationForm.ribbon_text_colors,
                  data.index,
                  ribbonInfo.color_text
                );
                this.$set(
                  this.calibrationForm.ribbon_names,
                  data.index,
                  ribbonInfo.color_name
                );
                this.$set(
                  this.calibrationForm.ribbon_ids,
                  data.index,
                  ribbonInfo.ribbon_id
                );
              } else {
                this.clearRibbonData(data.index);
              }
            } else {
              this.clearRibbonData(data.index);
            }
            break;

          case 'calibration_types_sel':
            if (Array.isArray(this.calibrationForm.calibration_types_sel)) {
              this.$set(
                this.calibrationForm.calibration_types_sel,
                data.index,
                data.selects
              );
            }
            break;

          default:
            console.warn(
              `El nombre de campo ${data.name} no está siendo manejado en el objeto.`
            );
            break;
        }
      } catch (error) {
        console.error(error.message);
      }
    },

    clearRibbonData(index) {
      this.$set(this.calibrationForm.ribbon_codes, index, null);
      this.$set(this.calibrationForm.ribbon_text_colors, index, null);
      this.$set(this.calibrationForm.ribbon_names, index, null);
      this.$set(this.calibrationForm.ribbon_ids, index, null);
    },

    getLots(farmId) {
      Axios.getMasters('lots/' + farmId)
        .then((response) => {
          this.lots = response.data.data;
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    },

    cleanFarm() {
      this.messageAlert = null;
      this.calibrationForm.farm_id = null;
      this.calibrationForm.calibration = [];
      this.calibrationForm.gang = null;
      this.calibrationForm.nCalibration = 1;
    },

    cleanLot() {
      this.messageAlert = null;
      this.calibrationForm.farm_id = null;
      this.calibration = false;
    },

    cleanAll() {
      this.cleanForm();
      this.calibration = false;
    },

    cleanForm() {
      this.calibration_catch_header_id = null;
      this.calibrationForm.lots_sel = [];
      this.calibrationForm.nCalibration = 1;
      this.calibrationForm.ages_sel = [];
      this.calibrationForm.calibration_type_id = null;
      this.calibrationForm.calibration_types_sel = [];
      this.calibrationForm.calibration = [];
      this.calibrationForm.ribbon_codes = [];
      this.calibrationForm.ribbon_ids = [];
      this.calibrationForm.ribbon_text_colors = [];
      this.calibrationForm.ribbon_names = [];
      this.calibrationForm.observation = '';
      this.numRowsToAdd = 1;
    },

    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.calibrationForm.calendar_sel = null;
      this.calibration = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.calibrationForm.farm_id
      );
      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.calibrationForm.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }

      this.isShowCalendar = false;
      this.calibrationForm.lot_id = null;
      this.getLots(this.calibrationForm.farm_id);
      this.hideView();
    },

    validate() {
      if (this.calibrationForm.farm_id == null) {
        return this.validationInputsRequired('farm');
      } else if (this.calibrationForm.date_sel == null) {
        return this.validationInputsRequired('date');
      } else if (this.calibrationForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else if (this.calibrationForm.lot_id == null) {
        return this.validationInputsRequired('lots');
      } else {
        this.messageAlert = null;
        this.loadCalibrations();
        this.cleanForm();

        return true;
      }
    },

    validateCalibration() {
      return new Promise((resolve, reject) => {
        this.showHideLoading(true);
        this.$validator
          .validateAll({
            ages_sel: this.calibrationForm.ages_sel,
          })
          .then(() => {
            for (let i = 0; i < this.calibrationForm.nCalibration; i++) {
              if (!isset(this.calibrationForm.calibration_types_sel[i])) {
                this.validationInputsRequired(`calibration_types`);

                reject(false);
              }
              if (
                !isset(this.calibrationForm.calibration[i]) ||
                this.calibrationForm.calibration[i] < 0
              ) {
                this.validationInputsRequired(`calibration`);

                reject(false);
              }

              const calValue = parseFloat(this.calibrationForm.calibration[i]);

              if (!isNaN(calValue) && (calValue <= 28 || calValue >= 60)) {
                this.showHideLoading(false);
                SweetAlert.warning(
                  `${i18n.t('calibration.value_row_calibration')} ${
                    i + 1
                  }: (${calValue}°) ${i18n.t(
                    'calibration.outside_allowed_range'
                  )}`
                );

                return reject(false);
              }
            }
            this.showHideLoading();

            resolve(true);
          })
          .catch(() => {
            this.showHideLoading();

            reject(false);
          });
      });
    },

    async saveCalibration() {
      try {
        await this.validateCalibration();
      } catch (error) {
        this.showHideLoading();
        console.warn('La validación del formulario falló.');
        return;
      }

      this.showHideLoading(true);
      await this.setLocation();

      const data = {
        route: 'calibration/catchs',

        id: this.calibration_catch_header_id || null,
        farm_id: this.calibrationForm.farm_id,
        lot_id: this.calibrationForm.lot_id,
        gang: this.calibrationForm.gang || null,
        date_save: moment(this.calibrationForm.date_sel).format('YYYY-MM-DD'),
        user_id: this.calibrationForm.user_id,
        observation: this.calibrationForm.observation || '',

        details: Array.from({ length: this.calibrationForm.nCalibration }).map(
          (_, index) => ({
            cluster: this.calibrationForm.clusters[index],
            calibration_type_id:
              this.calibrationForm.calibration_types_sel[index],
            age: this.calibrationForm.ages_sel[index] || 0,
            calibration: this.calibrationForm.calibration[index] || 0,
            ribbon_id: this.calibrationForm.ribbon_ids[index] || null,
            latitude: String(this.calibrationForm.latitude[index]),
            longitude: String(this.calibrationForm.longitude[index]),
            altitude: String(this.calibrationForm.altitude[index] || 0),
          })
        ),
      };

      const request = this.calibration_catch_header_id
        ? Axios.updateMaster(data)
        : Axios.postMasters(data);

      await request
        .then((response) => {
          this.showHideLoading();
          this.cleanAll();
          SweetAlert.success(response.data.message);
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(
            error.response.data.message || 'Ocurrió un error al guardar.'
          );
        });
    },

    loadCalibrations() {
      this.showHideLoading(true);
      let date = moment(this.calibrationForm.date_sel).format('YYYY-MM-DD');

      this.ribbonColorsByAge = [];

      const gangParam = this.calibrationForm.gang
        ? this.calibrationForm.gang
        : 'null';

      Promise.all([
        Axios.getMasters(
          `calibration/catchs/${date}/${this.calibrationForm.farm_id}/${this.calibrationForm.lot_id}/${gangParam}`
        ),
        Axios.getMasters(
          `calibration/ribbons/colors/${date}/${this.calibrationForm.farm_id}`
        ),
      ])
        .then(([calibrationResponse, ribbonColorsResponse]) => {
          const calibrationRes = calibrationResponse.data.data;
          this.ribbonColorsByAge = ribbonColorsResponse.data.colors_by_age;

          if (
            calibrationRes &&
            calibrationRes.details &&
            calibrationRes.details.length > 0
          ) {
            this.calibrationForm.clusters = [];
            this.has_details = true;

            this.calibrationForm.observation = calibrationRes.observation;
            this.calibrationForm.gang = calibrationRes.gang;
            this.calibrationForm.nCalibration = calibrationRes.details.length;

            this.calibration_catch_header_id = calibrationRes.header_id;

            calibrationRes.details.forEach((detail) => {
              this.calibrationForm.clusters.push(detail.cluster);
              this.calibrationForm.calibration.push(detail.calibration);
              this.calibrationForm.latitude.push(detail.latitude);
              this.calibrationForm.longitude.push(detail.longitude);
              this.calibrationForm.altitude.push(detail.altitude);
              this.calibrationForm.ribbon_ids.push(detail.ribbon_id);

              this.calibrationForm.ages_sel.push(detail.age);
              this.calibrationForm.calibration_types_sel.push(
                detail.calibration_type_id
              );

              this.calibrationForm.ribbon_codes.push(detail.ribbon_color);
              this.calibrationForm.ribbon_names.push(detail.ribbon_name);
              this.calibrationForm.ribbon_text_colors.push(
                detail.ribbon_text_color
              );
            });
          } else {
            this.cleanAll();
          }

          this.calibration = true;
          this.showHideLoading();
        })
        .catch((error) => {
          this.calibration = true;
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    deleteCalibrationDetails() {
      if (this.has_details) {
        SweetAlert.delete(i18n.t('production.capture_details')).then(
          (result) => {
            if (result.value) {
              let data = {
                id: this.calibration_catch_header_id,
                route: `calibration/catchs/delete`,
              };
              Axios.destroyMaster(data)
                .then((response) => {
                  this.showHideLoading();
                  this.cleanAll();
                  this.calibration = false;
                  SweetAlert.success(response.data.message);
                })
                .catch((error) => SweetAlert.warning(error));
            }
          }
        );
      } else {
        SweetAlert.warning(i18n.t('production.no_record_to_delete'));
      }
    },

    changeGang(value) {
      if (value === null || value === undefined) {
        this.calibrationForm.gang = null;

        return;
      }

      let valStr = String(value);
      if (valStr.length > 4) {
        valStr = valStr.slice(0, 4);
        this.calibrationForm.gang = valStr;
      }

      if (this.calibration === true) {
        this.cleanAll();
      }
    },
  },

  created() {
    this.showHideLoading(true);

    if (this.isIndex()) {
      Axios.getMasters('calibration/calibrationtypes')
        .then((response) => {
          this.calibrationTypes = response.data.data;
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    }

    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.getMasters('farms/farms/only')])
        .then(([farmsResponse]) => {
          this.farms = farmsResponse.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('calibration');
  },

  destroyed() {
    this.deselectedItemOnMenu('calibration');
  },
};
</script>
<style scoped>
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}

.custom-td-pd {
  padding: 0px !important;
}

.table-responsive {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
}

.cusmtom-thead-color {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
